// extracted by mini-css-extract-plugin
module.exports = {"canvas-component":"canvas-component--38DNs"};